import React from 'react';
import { Link } from 'react-router-dom';

/**
 * BrandLogo — 헤더 좌측 부냥 로고 (v2, 2026-09-21).
 *
 * 목업 .logo: 심볼(docs/design-v2/assets/voonang-mark.png → public/voonang-mark.png) + "부냥" 워드마크.
 * 앱바 22px / GNB(md+) 26px 높이, 워드마크 #FF6B00 800.
 *
 * 이전(Concept A)에는 SiteSettings.logo(관리자 업로드 PNG, 구 오렌지)를 우선 표시했으나
 * v2 에서 로고 오렌지를 #FF6B00 으로 통일하기 위해 정적 심볼로 교체.
 * (SiteSettings.logo 는 SplashScreen 등에서 계속 사용 — 운영 DB 교체는 대표 확인 항목)
 */

const MARK_SRC = '/voonang-mark.png';

export interface BrandLogoProps {
  /** 클릭 시 이동할 경로 (기본: '/') */
  to?: string;
  /** 심볼 높이 px 강제 (미지정 시 모바일 22 / md+ 26) */
  height?: number;
  className?: string;
}

export const BrandLogo: React.FC<BrandLogoProps> = ({ to = '/', height, className = '' }) => (
  <Link
    to={to}
    className={`flex shrink-0 items-center gap-[5px] ${className}`}
    aria-label="부냥 홈"
  >
    <img
      src={MARK_SRC}
      alt=""
      style={height ? { height, width: 'auto' } : undefined}
      className={`block w-auto select-none ${height ? '' : 'h-[22px] md:h-[26px]'}`}
      draggable={false}
      loading="eager"
      decoding="async"
    />
    <span className="text-[18px] font-extrabold leading-none text-accent md:text-[22px]">부냥</span>
  </Link>
);

export default BrandLogo;
